import React, { useState } from "react";
import { Row, Col, FormGroup, Label, Input, Button } from "reactstrap";
import { Filter, X } from "react-feather";

/**
 * PartnersFilter - Filter component for partners view
 */
const PartnersFilter = ({ filters, onApplyFilters, onClearFilters }) => {
  const [localFilters, setLocalFilters] = useState(filters);

  const handleChange = (field, value) => {
    setLocalFilters((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleApply = () => {
    onApplyFilters(localFilters);
  };

  const handleClear = () => {
    const defaultFilters = {
      name: "",
      sort: "-createdAt",
    };
    setLocalFilters(defaultFilters);
    onClearFilters();
  };

  return (
    <div className="partners-filter mb-3 p-3 border rounded">
      <h6 className="mb-3">
        <Filter size={16} className="me-2" />
        Filters
      </h6>
      <Row>
        <Col md="6">
          <FormGroup>
            <Label for="filterName">Partner Name</Label>
            <Input
              id="filterName"
              type="text"
              placeholder="Search by partner name..."
              value={localFilters.name}
              onChange={(e) => handleChange("name", e.target.value)}
            />
          </FormGroup>
        </Col>
        <Col md="4">
          <FormGroup>
            <Label for="filterSort">Sort By</Label>
            <Input
              id="filterSort"
              type="select"
              value={localFilters.sort}
              onChange={(e) => handleChange("sort", e.target.value)}
            >
              <option value="-createdAt">Newest First</option>
              <option value="createdAt">Oldest First</option>
              <option value="name">Name A-Z</option>
              <option value="-name">Name Z-A</option>
              <option value="-activeLicenseCount">Most Active Licenses</option>
              <option value="activeLicenseCount">Least Active Licenses</option>
              <option value="-totalLicenseCount">Most Total Licenses</option>
              <option value="totalLicenseCount">Least Total Licenses</option>
            </Input>
          </FormGroup>
        </Col>
        <Col md="2" className="d-flex align-items-end">
          <FormGroup>
            <Button
              color="primary"
              onClick={handleApply}
              className="w-100"
              title="Apply Filters"
            >
              <Filter size={14} />
            </Button>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col>
          <Button
            color="secondary"
            size="sm"
            outline
            onClick={handleClear}
          >
            <X size={14} className="me-1" />
            Clear Filters
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default PartnersFilter;
